import Icon from '../components/Icon.vue'

Icon.register({
  'tachometer-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 32C128.9 32 0 160.9 0 320 0 372.8 14.3 422.3 39.1 464.8 44.7 474.4 55.4 480 66.5 480H509.5C520.6 480 531.3 474.4 536.9 464.8 561.8 422.3 576 372.8 576 320 576 160.9 447.1 32 288 32zM288 96C302.7 96 314.6 106.1 318.3 119.6 317.2 121.9 315.7 123.9 314.9 126.3L305.6 154C300.5 157.5 294.7 160 288 160 270.3 160 256 145.7 256 128S270.3 96 288 96zM96 384C78.3 384 64 369.7 64 352S78.3 320 96 320 128 334.3 128 352 113.7 384 96 384zM144 224C126.3 224 112 209.7 112 192S126.3 160 144 160 176 174.3 176 192 161.7 224 144 224zM390.8 151.6L329.4 335.6C343.1 347.3 352 364.5 352 384 352 395.7 348.6 406.6 343.1 416H232.9C227.4 406.6 224 395.7 224 384 224 350.1 250.5 322.6 283.9 320.4L345.2 136.4C349.4 123.8 363 116.9 375.6 121.2 388.2 125.4 395 139 390.8 151.6zM405.4 208.8L420.9 162.2C424.4 160.9 428.1 160 432 160 449.7 160 464 174.3 464 192S449.7 224 432 224C420.6 224 411.1 217.7 405.4 208.8zM480 384C462.3 384 448 369.7 448 352S462.3 320 480 320 512 334.3 512 352 497.7 384 480 384z'
      }
    ]
  }
})
